
class SupplierOrderCell extends StockNoteCell
{
    set item (item:StockNote){
        this.setItem(item);
        this.setTitle(item.destinationName);
    }
}